import axios from "axios";

export const getAbout = async () => {
	return axios.get("/about")
		.catch(err => err);
};